import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'

export interface ExaminationDataReq {
  device_id?: string
}

export interface ExaminationDataRes {
  /** 体检详情 */
  exam_detail: string
  /** 最近体检时间，时间戳(秒) */
  examination_time: number
  /** 体检状态 e */
  physical_exam_status: number
  /** 分组id */
  group_id?: number
  /** 分组名 */
  group_name?: string
  /** 体检得分 */
  score?: number
  /** 登记用户名 */
  user_mark?: string
}

@Injectable()
export class ExaminationInfoService {
  constructor (private http: Http) {
  }

  @InvokeThrottle()
  getExaminationData (options: ExaminationDataReq) {
    return this.http.post<ExaminationDataRes>('/safemonitor/examination/info', options).then(res => {
      const exam_detail = JSON.parse(res.exam_detail || '{}')
      Object.keys(exam_detail).forEach(key => {
        let count = 0
        Object.keys(exam_detail[key]).forEach(subKey => {
          if (key === 'garbage') {
            count += (exam_detail[key][subKey] ? 1 : 0)
          } else {
            count += exam_detail[key][subKey]
          }
        })
        exam_detail[key].count = count
      })
      return { ...res, exam_detail }
    })
  }
}
